// Mappers for time-related entities
// Identity mappers for 1:1 mapping

import type { CheckTimeInfoResponseDto } from '@api/generated/models';

import type { WorldTimeApiResponse as WorldTimeApiResponseLocal } from '@api/modules/time/types';

import type { CheckTimeInfoResponse, WorldTimeApiResponse } from '@api/domain/types';

// Response mappers (identity for 1:1)
export const toCheckTimeInfoResponse = (dto: CheckTimeInfoResponseDto): CheckTimeInfoResponse => dto;

// Local type mappers (identity for 1:1)
export const toWorldTimeApiResponse = (dto: WorldTimeApiResponseLocal): WorldTimeApiResponse => dto;
